import request from "@/utils/request";
import config from "@/config";
import { getToken } from "@/utils/auth"; // get token
let serveUrl = config.baseUrl;

let personalCenterBaseUrl = config.personalCenterBaseUrl;

let adminCenterUrl = config.adminCenterUrl;
let token = '';


export function getPersonalDetail(data) {
  return request({
    url: `https://portal-service.nwpu.edu.cn/portalCenter/api/open/v1/account/defaultSfzh`,
    method: "get",
		header: 'portal',
		params: data
  });
}

// 获取定时任务列表数据
export function getTimedTaskList(data) {
  return request({
    url: `https://portal-service.nwpu.edu.cn/portalCenter/api/rest/quartz/getJobList?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
    // url: `http://192.168.2.59:20001/portalCenter/api/rest/quartz/getJobList?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
    method: "get",
		header: 'portal',
    // header:'open',
  });
}

// 新增定时任务
export function addTimedTaskList(data) {
  return request({
    url: `https://portal-service.nwpu.edu.cn/portalCenter/api/rest/quartz/addJob`,
    // url: `http://192.168.2.59:20001/portalCenter/api/rest/quartz/addJob`,
    method: "post",
		header: 'portal',
    // header:'open',
    data:data
  });
}

// 修改定时任务
export function editTimedTaskList(data) {
  return request({
    url: `https://portal-service.nwpu.edu.cn/portalCenter/api/rest/quartz/updateJob`,
    // url: `http://192.168.2.59:20001/portalCenter/api/rest/quartz/updateJob`,
    method: "post",
		header: 'portal',
    // header:'open',
    data:data
  });
}

// 删除定时任务 
export function deleteTimedTaskList(data) {
  return request({
    url: `https://portal-service.nwpu.edu.cn/portalCenter/api/rest/quartz/deletJob`,
    // url: `http://192.168.2.59:20001/portalCenter/api/rest/quartz/deletJob`,
    method: "post",
		header: 'portal',
    // header:'open',
    data:data
  });
}


// 恢复定时任务 
export function resumeTimedTaskList(data) {
  return request({
    url: `https://portal-service.nwpu.edu.cn/portalCenter/api/rest/quartz/resumeJob`,
    // url: `http://192.168.2.59:20001/portalCenter/api/rest/quartz/resumeJob`,
    method: "post",
		header: 'portal',
    // header:'open',
    data:data
  });
}

// 暂停定时任务 
export function pauseTimedTaskList(data) {
  return request({
    url: `https://portal-service.nwpu.edu.cn/portalCenter/api/rest/quartz/pauseJob`,
    // url: `http://192.168.2.59:20001/portalCenter/api/rest/quartz/pauseJob`,
    method: "post",
		header: 'portal',
    // header:'open',
    data:data
  });
}

// 日志列表数据 
export function getLogsList(data) {
  return request({
    url: `https://portal-service.nwpu.edu.cn/portalCenter/api/rest/quartz/getLogs?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
    // url: `http://192.168.2.59:20001/portalCenter/api/rest/quartz/getLogs?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
    method: "get",
		header: 'portal',
    // header:'open',
  });
}

// 日志的重发功能
export function repeatLogsList(data) {
  return request({
    url: `https://portal-service.nwpu.edu.cn/portalCenter/api/rest/quartz/reSend`,
    // url: `http://192.168.2.59:20001/portalCenter/api/rest/quartz/reSend`,
    method: "get",
		header: 'portal',
    // header:'open',
    params:data
  });
}

// 删除日志
export function deleteDailyList(data) {
  return request({
    url: `https://portal-service.nwpu.edu.cn/portalCenter/api/rest/quartz/deletLogs`,
    // url: `http://192.168.2.59:20001/portalCenter/api/rest/quartz/deletLogs`,
    method: "post",
		header: 'portal',
    // header:'open',
    data:data
  });
}

// 校验corn
export function validateCorn(data) {
  return request({
    url: `https://portal-service.nwpu.edu.cn/portalCenter/api/rest/quartz/validCron?cron=${data.corn}`,
    // url: `http://192.168.2.59:20001/portalCenter/api/rest/quartz/validCron?cron=${data.corn}`,
    method: "get",
		header: 'portal',
    // header:'open',
  });
}

export function registerAccount(data) {
  token = getToken();
  return request({
    url: `https://portal-service.nwpu.edu.cn/portalCenter/api/rest/center/personalData/addUser`, //创建上网账号信息
    method: "POST",
    headerType: 'xgd',
    data: data,
    params: {},
    token: token
  });
}

export function getMailSuffix(data) {
  token = getToken();
  return request({
    url: `https://portal-service.nwpu.edu.cn/portalCenter/api/rest/center/personalData/api/userData/getMailSuffix`, //获取邮箱后缀
    method: "get",
    headerType: 'xgd',
    params: data,
    token: token
  });
}

export function registerEmailBox(email) {
  token = getToken();
  return request({
    url: `https://portal-service.nwpu.edu.cn/portalCenter/api/rest/center/personalData/api/userData/registerEmailBox`, //注册邮箱 
    method: "POST",
    headerType: 'xgd',
    data: email,
    token: token
  });
}

export function saveEmailBox(email) {
  token = getToken();
  return request({
    url: `https://portal-service.nwpu.edu.cn/portalCenter/api/rest/center/personalData/api/userData/saveEmailBox`, //绑定邮箱 
    method: "POST",
    headerType: 'xgd',
    data: email,
    token: token
  });
}